import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]

import { ref, onMounted, PropType } from 'vue';
import { hideUrlPopup } from '.';
import Popup from '@/components/Popup/Index.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
    url: {
        type: String,
        required: true,
        default: ''
    },
    positionType: {
        type: String as PropType<'top' | 'bottom' | 'left' | 'right' | 'center'>,
        default: 'center'
    },
    style: {
        type: Object
    },
    isCanClose: {
        type: Number,
        default: 1
    },
    closeFn: {
        type: Function,
        default: () => { null }
    },
},
  setup(__props) {

const props = __props

const show = ref(false)
onMounted(() => {
    show.value = true
})


const type = ref<'img' | 'iframe' | ''>('')
const reg = /.+\.(jpg|jpeg|gif|bmp|png)$/;
if (!reg.test(props.url)) {
    type.value = 'iframe'
} else {
    type.value = 'img'
}


const defStyle = ref({
    width: '83vw',
    height: '76vh',
    backgroundColor: '#fff',
    borderRadius: '12px'
})


const close = () => {
    hideUrlPopup()
    props.closeFn()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    modelValue: show.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    type: __props.positionType
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "dialog-box",
        style: _normalizeStyle({ ...defStyle.value, ...__props.style })
      }, [
        (type.value == 'iframe')
          ? (_openBlock(), _createElementBlock("iframe", {
              key: 0,
              src: __props.url,
              frameborder: "0",
              width: "100%",
              height: "100%",
              allowtransparency: "true"
            }, null, 8, _hoisted_1))
          : _createCommentVNode("", true),
        (type.value == 'img')
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: "init-dialog-img",
              src: __props.url,
              style: _normalizeStyle({objectFit: __props.positionType == 'center' ? 'contain' : 'cover'})
            }, null, 12, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "close",
          onClick: close
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("svg", {
            t: "1689575118257",
            class: "icon",
            viewBox: "0 0 1024 1024",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "p-id": "3180",
            width: "100%",
            height: "100%"
          }, [
            _createElementVNode("path", {
              d: "M512 128C300.8 128 128 300.8 128 512s172.8 384 384 384 384-172.8 384-384S723.2 128 512 128zM512 832c-179.2 0-320-140.8-320-320s140.8-320 320-320 320 140.8 320 320S691.2 832 512 832z",
              "p-id": "3181",
              fill: "#ffffff"
            }),
            _createElementVNode("path", {
              d: "M672 352c-12.8-12.8-32-12.8-44.8 0L512 467.2 396.8 352C384 339.2 364.8 339.2 352 352S339.2 384 352 396.8L467.2 512 352 627.2c-12.8 12.8-12.8 32 0 44.8s32 12.8 44.8 0L512 556.8l115.2 115.2c12.8 12.8 32 12.8 44.8 0s12.8-32 0-44.8L556.8 512l115.2-115.2C684.8 384 684.8 364.8 672 352z",
              "p-id": "3182",
              fill: "#ffffff"
            })
          ], -1)
        ]))])
      ], 4)
    ]),
    _: 1
  }, 8, ["modelValue", "type"]))
}
}

})